import { DottedBorder } from "./GradientBorder";

interface ListTableProps {
  header: React.ReactNode;
  children: React.ReactNode;
}

export function ListTable({ header, children }: ListTableProps) {
  return (
    <div className='tw-space-y-0'>
      {header}
      <div className='tw-relative'>
        <DottedBorder color='light' side='bottom' />
      </div>
      <ul className='tw-space-y-0'>{children}</ul>
    </div>
  );
}

interface ListTableRowProps {
  children: React.ReactNode;
}

export function ListTableRow({ children }: ListTableRowProps) {
  return (
    <li>
      {children}
      <div className='tw-relative'>
        <DottedBorder color='light' side='bottom' />
      </div>
    </li>
  );
}
